"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _QuarterPicker = _interopRequireDefault(require("./QuarterPicker.vue"));
var _default = exports.default = {
  name: 'YsQuarterRange',
  components: {
    QuarterPicker: _QuarterPicker.default
  },
  props: {
    value: {
      type: Array,
      default: () => [(0, _moment.default)().startOf().format('YYYY-MM-DD'), (0, _moment.default)().endOf().format('YYYY-MM-DD')]
    },
    valueFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss'
    },
    allowClear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectRange: [undefined, undefined],
      startValue: undefined,
      endValue: undefined,
      startOpen: false,
      endOpen: false
    };
  },
  watch: {
    value: {
      handler([startTime, endTime] = []) {
        this.startValue = startTime;
        this.endValue = endTime;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    moment: _moment.default,
    disabledQuarter(currentQuarter, currentYear) {
      if (!this.startValue) {
        return true;
      }
      const startDate = (0, _moment.default)(this.startValue);
      const currentDate = (0, _moment.default)().year(currentYear).quarter(currentQuarter);
      return currentDate <= startDate;
    },
    handleClear() {
      this.startValue = {
        year: undefined,
        quarter: undefined
      };
      this.endValue = {
        year: undefined,
        quarter: undefined
      };
    },
    handleCancel() {
      this.startValue = this.value[0];
      this.endValue = this.value[1];
    },
    handleStartChange() {
      this.endOpen = true;
    },
    handleEndChange() {
      const {
        startValue,
        endValue
      } = this;
      const newStartValue = (0, _moment.default)(startValue).startOf('quarter').format(this.valueFormat);
      const newEndValue = (0, _moment.default)(endValue).endOf('quarter').format(this.valueFormat);
      const value = [newStartValue, newEndValue];
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};